export default {
  'Submit': 'Submit',
  'Save': 'Save',
  'enterOTP': 'Confirm your number',
  'otpSent': 'OTP Sent',
  'login/signup': 'Welcome to OYO',
  'resendCode': 'Resend Code',
  'edit': 'Edit',
  'otpMessage': 'Enter the OTP we have sent via SMS to your mobile number',
  'oyo360WelcomeMessage': 'Welcome to OYO',
  'oyo360ResendCode': 'Resend Code',
  'oyo360Edit': 'Edit',
  'logout': 'Logout',
  'oyo360otpMessage': 'Enter the code we have sent via SMS to your mobile number',
  'buttonActionContinue': 'Continue',
  'chooseLanguage': 'Choose a Language',
  'currentLanguage': 'CURRENT LANGUAGE',
  'otherLanguages': 'OTHER LANGUAGES',
  'google': 'Google',
  'facebook': 'Facebook',
  'or': 'or',
  'orContinueWith': 'Or continue with',
  'buttonActionSubmit': 'Submit',
  'signingIn': 'Signing In',
  'mobileNumberPlaceholder': 'Enter Phone Number',
  'loginSubText': 'Please enter your phone number to become an OYO in just 30 minutes',
  'welcomeTitle': 'Welcome to OYO',
  'welcomeHeadingForMailLogin': 'Enter the registered email address associated with us',
  'welcomeHeadingForLogin': 'Enter the registered email address or phone number associated with us',
  'welcomeHeadingForPhoneLogin': 'Enter the registered mobile number associated with us',
  'emailIdLabel': 'Email Id',
  'userNameLabel': 'Email Id / Phone Number',
  'phoneNumberLabel': 'Phone number',
  'passwordLabel': 'Password',
  'newPasswordLabel': 'New Password',
  'confirmNewPasswordLabel': 'Confirm New Password',
  'emailErrorMessage': 'Please enter the correct email ID',
  'userNameErrorMessage': 'Please enter the correct Email Id / Phone Number',
  'phoneNumberErrorMessage': 'Please enter the correct phone number',
  'passwordErrorMessage': 'Please enter the correct password',
  'confirmPasswordErrorMessage': 'Password is not matched!',
  'generateNewPassword': 'Generate a new password',
  'loginButtonLabel': 'Login',
  'notRegisteredLogIn': "This number is not registered as an Owner's number in our system, request you to please login with Owner credentials.",
  'loginWithPhoneButtonLabel': 'Continue with Phone',
  'loginWithOtp': ' Login with OTP instead',
  'loginWithEmailButtonLabel': 'Continue with Email ID',
  'back': 'Back',
  'loginWithOtpTitle': 'Enter verification code',
  'loginWithOtpHeading': 'You will receive the OTP if phone number is registered with our systems',

  'listYourProperty': 'List Your Property',
  'listProperty': 'List property',
  'privacyPolicy': ' Privacy policy',
  'termsOfUse': 'Terms of use',
  'privacyFooterText': 'By logging into the account you are agreeing with our {termsOfUse} and {privacyPolicy}',
  'and': 'and',
  'verifyEmail': 'Verify Email Address',
  'verifyMobile': 'Verify Mobile Number',
  'forgotPasswordPhoneSubHeading': 'We will send you a 6-digit code to verify your phone number',
  'forgotPasswordMailSubHeading': 'We will send you a 6-digit code to verify your email ID',
  'newPasswordCondition1': 'Should have both Number & Symbol',
  'newPasswordCondition2': 'Should have atleast 8 characters',
  'newPasswordCondition3': 'Should have both lowercase & uppercase',
  'confirmLogin': 'Confirm & Login',
  'getOTP': 'Get OTP',
  'invalidInput': 'Invalid Input',
  'passwordResetMessage': 'Password generated successfully',
  'otpErrorMessage': 'Please enter correct OTP',
  'resendOtpSuccessMessage': 'OTP has been resend on your mobile number successfully',
  'InternalServerErrorMessage': 'Internal Server Error',
  'resetPasswordHeading': 'A 6-digit code was sent to your email and phone number',
  'whiteSpace': ' ',
  'secureInformation': 'Don\'t worry your information is secure with us',
  'termsOfService': 'Terms of Service',
  'termsOfServiceFooter': 'By selecting Continue below, I agree to the following {termsOfService}.',
  'termsOfServiceFooterSocial': 'By choosing any medium to continue, I agree to the following {termsOfService}.',
  'notFoundText': 'We couldn\'t find the page',
  'notFoundDescription': 'Either something went wrong or the page doesn\'t exist anymore',
  'goBackFromNotFoundPage': 'Go Back',
  'goBackToOyoOs': 'Go Back to OYO OS',
  'errorNoAssociatedHotels': 'You have no Hotels associated',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileSearchPlaceholder': 'Search',
  'truecaller': 'One tap login with Truecaller',
  'truecallerAppNotPresent': 'Truecaller app is not installed. Please login with OTP',
  'truecallerInfoMsg': 'You should have Truecaller app installed on this phone',
  'socialLoginSubText': 'Please choose a login method to continue',
  'passwordChangeInformationText': 'You will be logged out of all the devices after changing your password.',
  'apple': 'Login with Apple'
};
